import { getZaniaSocket } from "@/infra/sockets";
import { addNotification } from "@/shared/states/notification";
import { useEffect } from "react";
import { getAgentData, getAgentStateActions, useSelectedReviewResponse } from "../states";
import { AgentSocketEvents } from "../types/events";

export const useAgentNotifications = (agentId: string) => {
	const socket = getZaniaSocket();
	const { updateAgentMainData } = getAgentStateActions();
	const { id: selectedId = "", data: selectedData } =
		useSelectedReviewResponse(agentId);
	useEffect(() => {
		if (!socket) return;

		const handleApprovalNotification = (data: {
			user_id: string;
			task: string;
			file_url: string;
			control_ids: string[];
			agent_session_id: string;
			agent_session_step_id?: string;
		}) => {
			const agentData = getAgentData(agentId);
			if (!agentData || data.agent_session_id !== agentId) return;

			updateAgentMainData(agentId, {
				...agentData.mainData,
				approvedIds: [
					...new Set([...agentData.mainData.approvedIds, ...data.control_ids]),
				],
				lastUpdate: {
					timestamp: Date.now(),
					isRemoteUpdate: true,
				},
			});

			if (data.control_ids.length > 1) {
				addNotification({
				  title: `${data.control_ids.length} Responses accepted`,
				  message: "Zania will auto-fill these in final report",
				  type: "success",
				});
			  }
		};

		socket.on(
			AgentSocketEvents.CONTROL_APPROVED_NOTIFICATION,
			handleApprovalNotification,
		);

		return () => {
			socket.off(
				AgentSocketEvents.CONTROL_APPROVED_NOTIFICATION,
				handleApprovalNotification,
			);
		};
	}, [socket, agentId, updateAgentMainData, selectedData]);
};
